import { render } from "./institution.vue?vue&type=template&id=166f43d5&scoped=true"
import script from "./institution.vue?vue&type=script&lang=js"
export * from "./institution.vue?vue&type=script&lang=js"

import "./institution.vue?vue&type=style&index=0&id=166f43d5&scoped=true&lang=css"
import "./institution.vue?vue&type=style&index=1&id=166f43d5&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166f43d5"]])

export default __exports__